/**
 * 客户退货申请单 - 明细Part - 商品信息Tab - 表单定制
 */
export default {
  data() {
    return {
      formConfig: {}
    }
  },
  mounted() {
    if (this.mainTableName == 'DC_B_APPLY_ORDER') {
      if (this.isApplyOrderItemTab) {
        this.initForm()
        this.fkHandle()
      }
      window.addEventListener("beforeSaveAction", this.saveHandle, false)
      window.addEventListener("notificationOfMain", this.onNotificationOfMain, false);
    }
  },
  beforeDestroy() {
    if (this.mainTableName == 'DC_B_APPLY_ORDER') {
      window.removeEventListener("beforeSaveAction", this.saveHandle, false)
      window.removeEventListener("notificationOfMain", this.onNotificationOfMain, false);
    }
  },
  watch: {
    detailTableName(val) {
      if (val === 'DC_B_APPLY_ORDER_ITEM' && this.mainTableName === 'DC_B_APPLY_ORDER' && !this._applyOrderItemInited) {
        this._applyOrderItemInited = true
        this.initForm()
        this.fkHandle()
      }
    }
  },
  computed: {
    mainTableName() {
      return vm.$route.params.tableName
    },
    detailTableName() {
      return this.$attrs.tableName || this.tableName
    },
    isApplyOrderItemTab() {
      return this.mainTableName === 'DC_B_APPLY_ORDER' && this.detailTableName === 'DC_B_APPLY_ORDER_ITEM'
    }
  },
  methods: {
    initForm() {
      const form = {
        formData: [
          {
            colname: "PS_C_PRO_ID",
            style: 'dropSelect', // 输入框弹框单多选
            isActive: true,
            isdisabled: false,
            itemdata: {
              isBackRowItem: true,
              colid: 1700850554,
              colname: 'PS_C_PRO_ID', // 当前字段的名称
              datelimit: 'all',
              fkdisplay: 'drp', // 外键关联类型
              inputname: 'CP_C_SHOP_ID', // 这个是做中文类型的模糊查询字段，例如ENAME
              isfk: true, // 是否有fk键
              isnotnull: true, // 是否必填
              url: {
                tableSearchUrl: '/api/cs/dc/v1/applyOrder/getAvailableOrder',
              },
              AutoRequest: {},// 接口入参 - 模糊搜索时
              TableRequest: {},// 接口入参 - 下拉时
            },
            oneObj: (v) => {
              this.formConfig.formValue.PS_C_PRO_ID = v.ID
              // 联动赋值
              this.formConfig.formValue.QTY = v.rowItem.QTY.val
              this.formConfig.formValue.DISCOUNT = ''
              this.formConfig.formValue.PS_C_SKU_ID = v.rowItem.PS_C_SKU_ID.refobjid
              this.formConfig.formValue.IS_GIFT = v.rowItem.IS_GIFT.val === '是'
              this.formKey = Date.now()
            }
          },
          { colname: "QTY", style: 'input' },
          { colname: "DISCOUNT", style: 'input' },
          { colname: "IS_GIFT", style: 'checkbox', onlyBox: true },
        ],
        formValue: {},
        ruleValidate: {}
      }
      setTimeout(() => {
        const page = vm.$store.state[R3.getModuleName()]
        const nowTabForm = _.cloneDeep(page.tabPanels[page.tabCurrentIndex].componentAttribute.formData.data.inpubobj)
        const a = $utils.initFormConfig(nowTabForm, form);
        this.formConfig = a
        this.setParam()
        this.formKey = Date.now()
      }, 1000);
    },
    setParam() {
      this.$nextTick(() => {
        const updateData = $store.state[R3.getModuleName()].updateData['DC_B_APPLY_ORDER']
        if (!updateData) {
          return
        }
        const mainData = Object.keys(updateData.changeData).length ? updateData.changeData : updateData.default['DC_B_APPLY_ORDER']
        console.log('mainData::', mainData);
        const obj = {
          bill_no: mainData.SOURCE_BILL_NO || '',
          CP_C_CUSTOMER_ID: mainData.CP_C_CUSTOMER_ID ?
            mainData.CP_C_CUSTOMER_ID instanceof Array ?
              mainData.CP_C_CUSTOMER_ID.length ? mainData.CP_C_CUSTOMER_ID[0].ID : ''
              : mainData.CP_C_CUSTOMER_ID
            : '',
          flag: Date.now()
        }
        if (!this.formConfig.formData) {
          return
        }
        this.formConfig.formData[0].itemdata.AutoRequest = Object.assign({ colid: 1700850554 }, obj, { isdroplistsearch: false })
        this.formConfig.formData[0].itemdata.TableRequest = Object.assign({
          isdroplistsearch: true,
          refcolid: 1700850554,
        }, obj)
      })
    },
    onNotificationOfMain() {
      this.setParam()
    },
    saveHandle(v) {
      if (!this.isApplyOrderItemTab) {
        return
      }
      const subForm = _.cloneDeep(this.formConfig.formValue)
      subForm.IS_GIFT = subForm.IS_GIFT === true ? 1 : 0
      if (subForm.DISCOUNT === '') {
        delete subForm.DISCOUNT
      }
      // 仅在有商品数据时写入入参，避免空表单覆盖已有数据
      if (subForm.PS_C_PRO_ID || subForm.PS_C_SKU_ID) {
        if (!v.detail.parames.data[this.detailTableName]) {
          v.detail.parames.data[this.detailTableName] = [{
            ...subForm,
            ID: -1,
          }]
        } else {
          const dex = v.detail.parames.data[this.detailTableName].findIndex(i => i.ID == -1)
          if (dex !== -1) {
            v.detail.parames.data[this.detailTableName][dex] = {
              ...v.detail.parames.data[this.detailTableName][dex],
              ...subForm,
            }
          }
        }
      }
    },
    fkHandle() {
      R3.network.axios.interceptors.response.use((config) => {
        if (this.mainTableName != 'DC_B_APPLY_ORDER') {
          return config
        }
        const configData = config.data;
        if (config.config.url == '/api/cs/dc/v1/applyOrder/getAvailableOrder') {
          const { code, datas } = configData
          if (code === 0 && datas) {
            // const showTh = ['ID', 'PS_C_SKU_ID', 'QTY', 'DISCOUNT', 'IS_GIFT']
            // const th = datas.tabth.filter(i => showTh.includes(i.colname))
            datas.row = datas.row || []
            const th = datas.tabth
            const allTh = th.map(i => i.colname)
            th.forEach(i => {
              i.isak = i.colname == 'PS_C_SKU_ID'
            })
            configData.datas.tabth = th
            const td = datas.row.reduce((a, b) => {
              const obj = {}
              for (const key of allTh) {
                obj[key] = {
                  val: b[key] ? b[key].val : '',
                  refobjid: b[key] ? b[key].refobjid : '',
                }
              }
              a.push(obj)
              return a
            }, [])
            configData.datas.row = td
          }
        }
        return config
      })
    }
  }
}
